<template>
	<section class="category-list__section category-list__category">
		<h1 class="category-list__category__h1">
			<span class="category-list__category__h1__span">{{ title }}</span>
			<button
				@click="addCategory"
				class="btn-circle blue category-list__category__h1__button"
			>
				<i class="fa fas fa-plus"></i>
			</button>
		</h1>
		<div class="category-list__category__list">
			<ul>
				<li
					:key="`${item.id}`"
					v-for="item in list"
					class="category-list__category__item"
					:class="{
						'category-list__category__item--selected':
							item.id === selectedId,
						'category-list__category__item--not-display':
							!item.isDisplay,
					}"
					@click="selectAction(item.id)"
				>
					<span v-show="item.id !== 'entire'">[{{ item.id }}]</span>
					{{ item.name }}
				</li>
			</ul>
		</div>
		<div class="category-list__category__button-wrapper">
			<button
				@click="orderChange('up')"
				class="btn-circle"
				:class="{
					'btn-order--disabled': isTopOrEmpty,
				}"
			>
				<i class="fa fas fa-chevron-up"></i>
			</button>
			<button
				@click="orderChange('down')"
				class="btn-circle"
				:class="{
					'btn-order--disabled': isBottomOrEmpty,
				}"
			>
				<i class="fa fas fa-chevron-down"></i>
			</button>
		</div>
		<div class="category-list__category__button-wrapper">
			<button
				class="btn blue"
				v-if="showSaveOrderChange"
				@click="saveOrderChange"
			>
				변경된 순서 적용
			</button>
		</div>
	</section>
</template>
<script>
	import _ from 'lodash';

	export default {
		name: 'CategoryList',
		props: {
			title: String,
			list: {
				type: Array,
				default: () => [],
			},
			selection: {
				type: String,
				default: null,
			},
			selectAction: {
				type: Function,
				default: () => {},
			},
		},
		computed: {
			selectedId() {
				return this.$store.state.category.selection[this.selection];
			},
			showSaveOrderChange() {
				return this.$store.state.category.modified[
					`${this.selection}Order`
				];
			},
			isTopOrEmpty() {
				const index = _.indexOf(
					this.list,
					_.find(this.list, { id: this.selectedId })
				);
				const listLength = this.list.length;

				return index === -1 || index === 0 || listLength === 0;
			},
			isBottomOrEmpty() {
				const index = _.indexOf(
					this.list,
					_.find(this.list, { id: this.selectedId })
				);
				const listLength = this.list.length;

				return (
					index === -1 || index === listLength - 1 || listLength === 0
				);
			},
		},
		methods: {
			orderChange(direction) {
				if (this.selectedId === null || this.selectedId === 'entire') {
					return false;
				}

				const index = _.indexOf(
					this.list,
					_.find(this.list, { id: this.selectedId })
				);
				const prevOrNext = direction === 'up' ? index - 1 : index + 1;
				const listLength = this.list.length;
				const isNotTopOrBottom =
					direction === 'up'
						? index !== 0 && listLength > 1
						: index !== listLength - 1 && listLength > 1;

				if (isNotTopOrBottom) {
					this.$store.commit('category/orderChange', {
						selection: this.selection,
						currentId: this.list[index].id,
						prevOrNextId: this.list[prevOrNext].id,
					});
				}
			},
			addCategory() {
				let parentId = null;
				const depth = {
					category1st: '1차',
					category2nd: '2차',
					category3rd: '3차',
				};

				if (this.selection === 'category2nd') {
					if (!this.$store.state.category.selection.category1st) {
						alert('첫번째 카테고리를 선택해 주세요.');
						return false;
					} else {
						parentId =
							this.$store.state.category.selection.category1st;
					}
				} else if (this.selection === 'category3rd') {
					if (!this.$store.state.category.selection.category1st) {
						alert('첫번째 카테고리를 선택해 주세요.');
						return false;
					}
					if (!this.$store.state.category.selection.category2nd) {
						alert('두번째 카테고리를 선택해 주세요.');
						return false;
					} else {
						parentId =
							this.$store.state.category.selection.category2nd;
					}
				}

				this.$store.commit('category/setAddingStatus', {
					depth: this.selection,
					parentId,
				});
				this.$store.commit('modal/toggleModal', {
					id: 'CategoryAdding',
					contsTitle: `${depth[this.selection]} 카테고리 신규 등록`,
				});
			},
			saveOrderChange() {
				this.$store
					.dispatch('category/saveOrderChange')
					.then(orderedId => {
						const level = {
							category1st: 1,
							category2nd: 2,
							category3rd: 3,
						}[this.selection];

						this.$axiosAdmin2
							.put(`/api/categories/level/${level}/order`, {
								categoryOrders: orderedId,
							})
							.then(({ data }) => {
								this.$store.commit('category/orderChanged', {
									selection: this.selection,
								});

								alert('정렬순서가 변경되었습니다.');
							});
					});
			},
		},
	};
</script>
<style scoped lang="scss">
	SECTION {
		.btn {
			display: inline-block;
		}

		.btn-order--disabled {
			color: lightgray;
			border-color: lightgray;

			&:hover {
				border-color: lightgray;
			}
		}

		.category-list__section {
			flex: 1;
			padding: 1em;
		}

		.category-list__category__h1 {
			font-size: 1em;
			font-weight: bold;
			margin-bottom: 1em;
			color: #303643;

			&:after {
				content: '';
				clear: both;
				display: block;
			}
		}

		.category-list__category__h1__span {
			padding: 10px 0;
			display: inline-block;
		}

		.category-list__category__h1__button {
			vertical-align: middle;
			float: right;
		}

		.category-list__category__list {
			border: 1px solid #dfe6ee;
			padding: 1em;
			border-radius: 4px;
			min-height: 534px;
			height: 534px;
			overflow: auto;
		}

		.category-list__category__button-wrapper {
			text-align: center;
			padding-top: 1em;
		}

		.category-list__category__item {
			font-size: 1.125rem;
			padding: 10px 0;
			cursor: pointer;
			transition: padding 200ms cubic-bezier(1, 0, 0, 1);
		}

		.category-list__category__item--selected {
			background-color: #f4f7fa;
			color: #657088;
			padding-left: 0.5em;
			font-weight: bold;
		}

		.category-list__category__item--not-display {
			color: lightgray;
		}
	}
</style>
